import PropTypes from 'prop-types';

const Site = {
  id: PropTypes.string,
  name: PropTypes.string,
  updatedOn: PropTypes.string,
};

export default Site;
